// Wash for segments the partial translation preview left in English. Amber
// (stale), deliberately distinct from a search-match yellow. Chakra `amber.100`
// / `amber.800`, inlined because the editor stylesheet is raw CSS, not tokens.
export const EDITED_SINCE_PUBLISH_HIGHLIGHT = {
  bg: '#fef3c7',
  fg: '#92400e',
} as const;
